export default {
  "initial.extension.regression": function initialExtensionRegression() {
    var _this = this;

    return {
      "path.appearing": null,
      "path.updating": null,
      "path.disappearing": null,
      "group.appearing": function groupAppearing() {
        var a,
            b = _this,
            c = b.getFromEnv('chart'),
            d = c.getChildren('canvas')[0],
            e = 0,
            f = [],
            g = [];

        for (f.push(d.config.canvasLeft), f.push(d.config.canvasTop), f.push(0), f.push(d.config.canvasHeight), a = f.length; e < a;) {
          g.push(f[e]), e++;
        }

        return g[2] = d.config.canvasWidth, [{
          initialAttr: function initialAttr() {
            return {
              "clip-rect": f
            };
          },
          finalAttr: function finalAttr() {
            return {
              "clip-rect": g
            };
          },
          effect: 'linear',
          slot: 'plot'
        }];
      },
      "*": null
    };
  }
};